const orderList = () => import('@/views/main/order/list/list.vue')
export default {
  path: '/main/order/list',
  name: 'orderList',
  component: orderList,
  children: []
}
